import {
    IconButton,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableFooter,
    TableHead,
    TablePagination,
    TableRow,
    Tooltip,
} from '@mui/material';
import LinearProgress from '@mui/material/LinearProgress';
import { UserAdminPaginationDto } from '../../../../services/dtos/user-admin-pagination.dto';
import { env } from '../../../../env';
import { ConnectWithoutContact } from '@mui/icons-material';

/**
 * Composant du tableau des pages
 * @param props Pages à afficher
 * @constructor
 */
export default function SearchUserTable(props: {
    users?: UserAdminPaginationDto | null;
    isSearching: boolean;
    handleSwitchPageNumber(newPage: number): void;
    page: number;
    handlerLoggedInAs(id: string, name: string, firstName: string): void;
}) {
    // Nombre de lignes par page, géré par une variable d'environnement
    const rowsPerPage = Number(env.REACT_APP_NUMBER_ELEMENT_TABLE);
    // En-têtes des cellules du tableau
    const headCells = [
        {
            id: 'identifier',
            label: 'Identifiant',
            sort: false,
        },
        {
            id: 'birthName',
            label: 'Nom de naissance',
            sort: false,
        },
        {
            id: 'name',
            label: "Nom d'usage",
            sort: false,
        },
        {
            id: 'firstName',
            label: 'Prénom',
            sort: false,
        },
        {
            id: 'actions',
            label: 'Action',
            sort: false,
        },
    ];

    /**
     * Gestion du changement de page, avec la récupération d'une autre page de factures
     * @param event Événement
     * @param newPage Page à afficher
     */
    const handleOnPageChange = async (event: any, newPage: number) => {
        event.preventDefault();
        props.handleSwitchPageNumber(newPage);
    };

    return (
        // Container du tableau
        <TableContainer component={Paper}>
            {/*// Affichage du tableau*/}
            <Table>
                <TableHead>
                    <TableRow>
                        {/*En-têtes*/}
                        {headCells.map(headCell => (
                            <TableCell key={headCell.id} align={'left'} sx={{ fontWeight: 'bold', fontSize: 'medium' }}>
                                {headCell.label}
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                {/* Gestion du chargement des pages/tri avec une progress bar */}
                <TableBody>
                    {!props.isSearching ? (
                        // Lignes du tableau
                        props.users?.users?.map(row => (
                            <TableRow key={row.id}>
                                <TableCell>{row.identifiant}</TableCell>
                                <TableCell>{row.utilisateur.nomNaissance}</TableCell>
                                <TableCell>{row.utilisateur.nomUsage}</TableCell>
                                <TableCell>{row.utilisateur.prenom}</TableCell>
                                <TableCell>
                                    {/*Tooltip qui permet de faire l'action :*/}
                                    {/*Se connecter en tant que */}
                                    <Tooltip title={'Se connecter en tant que'} arrow>
                                        <IconButton
                                            onClick={() => {
                                                props.handlerLoggedInAs(
                                                    row.id,
                                                    row.utilisateur.nomUsage,
                                                    row.utilisateur.prenom
                                                );
                                            }}
                                        >
                                            <ConnectWithoutContact />
                                        </IconButton>
                                    </Tooltip>
                                </TableCell>
                            </TableRow>
                        ))
                    ) : (
                        //Affichage d'une barre de progression lors de la récupération des données
                        <TableRow>
                            <TableCell colSpan={headCells.length}>
                                <LinearProgress />
                            </TableCell>
                        </TableRow>
                    )}
                </TableBody>
                <TableFooter>
                    <TableRow>
                        {/*Options de pagination*/}
                        <TablePagination
                            count={props.users?.totalItems ? props.users?.totalItems : 0}
                            onPageChange={handleOnPageChange}
                            page={props.page}
                            rowsPerPage={rowsPerPage}
                            rowsPerPageOptions={[rowsPerPage]}
                            labelDisplayedRows={({ from, to, count }) => `${from} à ${to} sur ${count}`}
                            showFirstButton
                            showLastButton
                        />
                    </TableRow>
                </TableFooter>
            </Table>
        </TableContainer>
    );
}
